var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversationOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#CFEEDC",
    stroke: "#8ED1B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3,
    fill: "none",
    stroke: "#00A651",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    fill: "#00A651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationOpenIcon);
export default __webpack_public_path__ + "static/media/conversation-open-icon.98e2a42c06e950406671dc44458accec.svg";
export { ForwardRef as ReactComponent };